import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";

class Navbar extends Component {
    render() {
        return (
            <nav className="navbar navbar-expand-md navbar-dark">
                <div className="container">
                    <Link
                        className="navbar-brand"
                        style={{ fontSize: "1.5rem", letterSpacing: "0.3rem" }}
                        to="/"
                    >
                        FERDOUS HASAN
                    </Link>
                    <button
                        type="button"
                        className="navbar-toggler"
                        data-bs-toggle="collapse"
                        data-bs-target="#navBar"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div id="navBar" className="collapse navbar-collapse">
                        <ul className="navbar-nav ms-auto">
                            <li className="nav-item">
                                <Link className="nav-link text-capitalize">
                                    home
                                </Link>
                            </li>
                            <li className="nav-item">
                                <a
                                    href="#about"
                                    className="nav-link text-capitalize"
                                >
                                    about
                                </a>
                            </li>
                            <li className="nav-item">
                                <a
                                    href="#resume"
                                    className="nav-link text-capitalize"
                                >
                                    resume
                                </a>
                            </li>
                            <li className="nav-item">
                                <a
                                    href="#contact"
                                    className="nav-link text-capitalize"
                                >
                                    contact
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        );
    }
}

export default Navbar;
